module.exports = __webpack_public_path__ + "media/images/favicon/secondary/ms-icon-70x70-f03fc0f4185bbd38a7d57a9eb467e223.png";